import type { NetworkPayload } from "../../../composites";

export const API = {
  fetchZEscrow: (): NetworkPayload => {
    return {
      url: "/zescrow",
      options: {
        method: "GET",
      },
    };
  },
};
